import "./Home.css";
import React, { useEffect, useState } from "react";
import { GetNews } from "../../apis/api/NewsApi";
import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import { DashboardApi, RecentMember } from "../../apis/api/DashboardApi";
import { formatDMY } from "../../utils/date";

import Cookies from "js-cookie";
import Lodderr from "../../components/Lodder/Lodder";
import GeoChart from "./WorldMap";

const Dashboard = () => {
  const [timeLeft, setTimeLeft] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const company_id = Cookies.get("company_id");
  const user_id = Cookies.get("userID");

  const { dashboardData } = useSelector((state) => state.DashboardSlice);
  const { Recentmember } = useSelector((state) => state.DashboardSlice);

  const { loading } = useSelector((state) => state.DashboardSlice);

  const callAPIS = async () => {
    await dispatch(RecentMember());
    await dispatch(GetNews());
    await dispatch(DashboardApi({ company_id, user_id }));
  };

  useEffect(() => {
    callAPIS();
  }, []);

  // useEffect(() => {
  //   if (!dashboardData?.membership_expire) return;

  //   const expiryTimestamp = Number(dashboardData.membership_expire) * 1000;
  //   const startTimestamp = Number(dashboardData.membership_start) * 1000;
  //   const interval = setInterval(() => {
  //     const now = new Date().getTime();
  //     const distance = expiryTimestamp - now;

  //     if (distance <= 0) {
  //       clearInterval(interval);
  //       setTimeLeft({});
  //     } else {
  //       setTimeLeft({
  //         days: Math.floor(distance / (1000 * 60 * 60 * 24)),
  //         hours: Math.floor(
  //           (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  //         ),
  //         minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
  //         seconds: Math.floor((distance % (1000 * 60)) / 1000),
  //       });
  //     }
  //   }, 1000);

  //   return () => clearInterval(interval);
  // }, [dashboardData?.membership_expire]);

  useEffect(() => {
    if (!dashboardData?.membership_start || !dashboardData?.membership_expire) {
      setTimeLeft({});
      return;
    }
  
    const startTimestamp = Number(dashboardData.membership_start) * 1000;
    const expiryTimestamp = Number(dashboardData.membership_expire) * 1000;
  
    const interval = setInterval(() => {
      const now = Date.now();
  
 
      if (now < startTimestamp) {
        const distance = startTimestamp - now;
  
        setTimeLeft({
          status: 'not_started',
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          ),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000),
        });
        return;
      }
  

      if (now >= expiryTimestamp) {
        clearInterval(interval);
        setTimeLeft({ status: 'expired' });
        return;
      }
  

      const distance = expiryTimestamp - now;
  
      setTimeLeft({
        status: 'active',
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        ),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000),
      });
    }, 1000);
  
    return () => clearInterval(interval);
  }, [
    dashboardData?.membership_start,
    dashboardData?.membership_expire
  ]);

  
  const bgClasses = [
    "bg-gradient-rainboww",
    "bg-gradient-burningg",
    "bg-gradient-moonlitt",
    "bg-gradient-cohsmic",
  ];
  const { news } = useSelector((state) => state.NewsSlice);

  const handleRedirect = (news) => {
    navigate("/newsArticle", {
      state: {
        newsData: news,
        from: location.pathname,
      },
    });
  };
  const formatDate = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(Number(timestamp) * 1000);
    return date
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-");
  };
  return (
    <>
      {loading && <Lodderr />}
      <div className=" ">
        <div className="p-4 rounded-4 shadow-lg countdown-card mb-4">
          {timeLeft == null ? (
            <div className="text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : timeLeft?.status === 'active'  ? (
            <div className="d-flex flex-column flex-md-row align-items-center justify-content-center gap-4">
              <div className="d-flex align-items-center">
                <i className="bi bi-hourglass-split text-primary fs-3 me-3"></i>
                <div>
                  <p className="mb-0 fs-5 fw-bold ">
                    Your membership plan expires in
                  </p>
                </div>
              </div>

              <div className="d-flex gap-3 flex-wrap justify-content-center align-items-center">
                <div className="modern-timer-box">
                  <span>{String(timeLeft.days).padStart(2, "0")}</span>
                  <small>Days</small>
                </div>
                <span className="colon-separator">:</span>
                <div className="modern-timer-box">
                  <span>{String(timeLeft.hours).padStart(2, "0")}</span>
                  <small>Hours</small>
                </div>
                <span className="colon-separator">:</span>
                <div className="modern-timer-box">
                  <span>{String(timeLeft.minutes).padStart(2, "0")}</span>
                  <small>Minutes</small>
                </div>
                <span className="colon-separator">:</span>
                <div className="modern-timer-box">
                  <span>{String(timeLeft.seconds).padStart(2, "0")}</span>
                  <small>Seconds</small>
                </div>
              </div>
            </div>
          ): timeLeft?.status === 'not_started'  ? 
          (
            <div className="text-center">
              <p className="fs-5 fw-bold mb-0">
                <i className="bi bi-exclamation-triangle-fill me-2"></i>
                Membership starts in {timeLeft.days}d {timeLeft.hours}h
              </p>
            </div>
          )
          : timeLeft?.status === 'expired' ? (
            <div className="text-center">
              <p className="fs-5 fw-bold text-danger mb-0">
                <i className="bi bi-exclamation-triangle-fill me-2"></i>
                Your membership has expired.
              </p>
            </div>
          ) : 
          (
            <div className="text-center">
              <p className="fs-5 fw-bold mb-0">
                <i className="bi bi-exclamation-triangle-fill me-2"></i>
                Membership Fetching...
              </p>
            </div>
          )}
        </div>

        <div className="row row-cols-1 row-cols-lg-4 g-8 ">
          <div
            className="col"
            onClick={() => {
              navigate("/user", { state: { from: location.pathname } });
            }}
          >
            <div
              className="card card-hover-zoom rounded-4 bg-gradient-rainbow bubble position-relative overflow-hidden cursor-pointer"
              title="Click to view"
              onClick={() =>
                navigate("/user", { state: { from: location.pathname } })
              }
            >
              <div className="card-body d-flex flex-column justify-content-evenly">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 className="mb-0 text-white">
                      {dashboardData?.total_registrations}
                    </h4>
                    <p className="mb-0 text-white">Total Companies</p>
                  </div>
                  <div className="fs-1 text-white">
                    <i className="bx bx-user-plus"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="col"
            onClick={() => {
              navigate("/activeMember", { state: { from: location.pathname } });
            }}
          >
            <div
              className="card card-hover-zoom rounded-4 bg-gradient-burning bubble position-relative overflow-hidden cursor-pointer"
              title="Click to view"
              onClick={() =>
                navigate("/activeMember", { state: { from: location.pathname } })
              }
            >
              <div className="card-body d-flex flex-column justify-content-evenly">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 className="mb-0 text-white">
                      {dashboardData?.active_members}
                    </h4>
                    <p className="mb-0 text-white">Active Members</p>
                  </div>
                  <div className="fs-1 text-white">
                    <i className="bx bx-user-check"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col" onClick={() => {
              navigate("/memberinCountry", { state: { from: location.pathname } });
            }}>
            
            <div className="card card-hover-zoom  rounded-4 bg-gradient-moonlit bubble position-relative overflow-hidden cursor-pointer">
              <div className="card-body d-flex flex-column justify-content-evenly">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 className="mb-0 text-white">
                      {dashboardData?.country_members}
                    </h4>
                    <p className="mb-0 text-white">
                      Members in {dashboardData?.country}
                    </p>
                  </div>
                  <div className="fs-1 text-white">
                    <i className="bx bx-globe"></i>
                  </div>
                </div>
                {/* <small className="text-white">+2.6% Since Last Week</small> */}
              </div>
            </div>
          </div>

          <div className="col">
            <div className="card card-hover-zoom rounded-4 bg-gradient-cosmic bubble position-relative">
              <div className="card-body p-2 d-flex flex-column justify-content-start overflow-auto">
                <div className="d-flex align-items-start justify-content-between  mt-2">
                  <h6 className="mb-0 text-white small flex-grow-1 me-2 ms-2">
                    {dashboardData?.plan_name?.split(":")[1]}
                  </h6>
                  <div className="fs-3 text-white flex-shrink-0">
                    <i className="bx bx-id-card"></i>
                  </div>
                </div>
                <p className="mb-0 text-white small ms-2">
                  <strong>Plan Started:</strong>{" "}
                  {formatDate(dashboardData?.membership_start)}
                </p>
                <p className="mb-0 text-white small ms-2">
                  <strong>Plan Ends:</strong>{" "}
                  {formatDate(dashboardData?.membership_expire)}
                </p>
              </div>
            </div>
          </div>
        </div>

        {news && (
          <div className="">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h3 className="mb-0 fw-bold text-dark d-flex align-items-center">
                <i className="bx bx-news fs-2 me-2 text-primary"></i>
                <span className="fs-4">News</span>
              </h3>
              <button
                className="btn btn-sm custom-btn"
                onClick={() =>
                  navigate("/news", { state: { from: location.pathname } })
                }
              >
                <i className="bx bx-news me-1"></i> View All
              </button>
            </div>

            <div className="row">
              {news?.slice(0, 4).map((item) => (
                <div
                  className="col-xl-3 col-lg-6 col-md-6 col-sm-12 mb-4"
                  key={item.id}
                >
                  <div className="shadow border-2 h-100 p-2 rounded-4 d-flex flex-column bg-white">
                    <img
                      src={item.image.replace("/thumb", "")}
                      className="card-img-top rounded-4"
                      alt={item.name}
                      style={{ height: "180px", objectFit: "cover" }}
                    />
                    <div className="card-body d-flex flex-column flex-grow-1">
                      <div
                        className="d-flex align-items-center gap-6 text-muted mb-2"
                        style={{ fontSize: "0.85rem" }}
                      >
                        <span>
                          <i className="bx bx-calendar me-1 mt-1"></i>
                          {formatDMY(item.date)}
                        </span>
                      </div>
                      <h5 className="fw-bold">{item.name}</h5>

                      {/* Title truncation block */}
                      <p
                        className="text-muted mb-3 flex-grow-1"
                        style={{
                          display: "-webkit-box",
                          WebkitLineClamp: 3, // show max 3 lines
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          minHeight: "3.6em", // roughly 3 lines of text height
                        }}
                      >
                        {item.title}
                      </p>

                      {/* Button aligned to bottom */}
                      <div className="mt-auto">
                        <button
                          className="btn text-white rounded-pill fw-semibold btn-sm btn-secondary"
                          onClick={() => handleRedirect(item)}
                        >
                          <i className="bx bx-book-reader me-1"></i>
                          Read More
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="mb-3">
          <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
            <h3 className="mb-0 fw-bold text-dark d-flex align-items-center">
              <i className="bx bx-news fs-2 me-2 text-primary"></i>
              <span className="fs-4">Recent Members</span>
            </h3>
            <button
              className="btn btn-sm custom-btn"
              onClick={() =>
                navigate("/recentMember", {
                  state: { from: location.pathname },
                })
              }
            >
              <i className="bx bx-group me-1"></i> View All
            </button>
          </div>

          <div className="row">
            {Array.isArray(Recentmember) && Recentmember.length > 0 ? (
              Recentmember.map((member, index) => {
                const bgClass = bgClasses[index % bgClasses.length];
                return (
                  <div
                    className="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-3 mt-3 d-flex"
                    key={`community-${member.id}`}
                  >
                    <div className={`card1 ${bgClass} h-100 d-flex flex-column justify-content-center align-items-center`}>
                      <div className="firstinfo d-flex align-items-center">
                        <img
                          src={member?.company_logo || "/company-logo-design.jpg"}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src =
                              process.env.PUBLIC_URL + "/company-logo-design.jpg";
                          }}
                          className="mb-2 rounded-circle"
                          style={{ width: "60px", height: "60px", objectFit: "cover" }}
                          alt={member.company_name}
                        />
                        <div className="profileinfo text-center">
                          <h5 className="fs-6 mb-1 text-truncate" style={{ maxWidth: "100px" }}>
                            {member.company_name}
                          </h5>
                          <p className="text-dark mb-0">{member.country}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="col-12">
                <div className="text-center py-4 text-muted">
                  <span>No recent members available</span>
                </div>
              </div>
            )}
          </div>


        </div>
        <h3 className="mb-0 fw-bold text-dark d-flex align-items-center">
          <span className="fs-4"> No of Member(s) In Different Countries</span>
        </h3>

        <GeoChart />
      </div>
    </>
  );
};

export default Dashboard;
